import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { programBoardList } from '@/network/apis/apiUri';
import NavData from '@/config/data/nav/nav_data.json';
import { MainHead, Pagination } from '../common';

export default function ProgramAnnouncement(props) {
  const { mode, history, selBoard, anchorTitle } = props;

  const [topData, setTopData] = useState();
  const [normalData, setNormalData] = useState();
  const [pageInfo, setPageInfo] = useState();

  const handlePageBtn = (e) => {
    const { value } = e.currentTarget;

    const searchParams = new URLSearchParams(history.location.search);
    const nowPage = searchParams.get('page') ?? 1;

    if (value === 'nextPage') {
      searchParams.set('page', +nowPage + 1);
    }
    if (value === 'prevPage') {
      searchParams.set('page', +nowPage - 1);
    }
    if (value === 'firstPage') {
      searchParams.set('page', 1);
    }
    if (value === 'lastPage') {
      searchParams.set('page', pageInfo.total_page_count);
    }
    if (!isNaN(Number(value))) {
      searchParams.set('page', value);
    }

    history.push(`?${searchParams.toString()}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams(history.location.search);

    const formData = new FormData(e.currentTarget);

    const searchOpt = formData.get('searchOpt');
    const searchText = formData.get('searchText') ?? '';

    if (searchOpt) searchParams.set('searchOpt', searchOpt);
    if (searchText) searchParams.set('searchText', searchText);
    else searchParams.delete('searchText');
    searchParams.delete('page');

    history.push(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const page = searchParams.get('page') ?? 1;
    const searchOpt = searchParams.get('searchOpt') ?? null;
    const searchText = searchParams.get('searchText') ?? null;

    programBoardList({
      board_id: selBoard.boardId,
      lan_code: mode,
      hit: true,
      reg_order: 'desc',
      key_word: searchOpt,
      word: searchText ? searchOpt : null,
      page_info: {
        row_count: 10,
        number: page - 1,
      },
    }).then((res) => {
      if (res.status === 200) {
        const _pageInfo = res.data.paging_info;
        const _data = res.data.item
          .filter((el) => !el.is_top)
          .map((el, i) => ({
            no: (topLength = 0) => _pageInfo.total_item_count - topLength - _pageInfo.number * (10 - topLength) - i,
            key: `Announce_${el.board_item_id}`,
            title: el.title,
            content: el.content.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
            hitCount: el.hit_count,
            regDate: el.reg_date ? el.reg_date.slice(0, 10) : '',
            upDate: el.update_date ? el.update_date.slice(0, 10) : '',
            link: `${NavData['RADIO_MAIN'].path}/${selBoard.programId}/board/${selBoard.boardId}/${el.board_item_id}`,
          }));
        setPageInfo(_pageInfo);
        if (_data.length) setNormalData(_data);
        else setNormalData(undefined);
      }
    });
    return () => {
      setTopData(undefined);
      setPageInfo(undefined);
      setNormalData(undefined);
    };
  }, [history.location]);

  useEffect(() => {
    programBoardList({
      board_id: selBoard.boardId,
      lan_code: mode,
      hit: true,
      reg_order: 'desc',
      key_word: 'top_allow',
      page_info: { row_count: -1, number: 0 },
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data.item.map((el) => ({
          key: `Announce_top_${el.board_item_id}`,
          title: el.title,
          content: el.content.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
          hitCount: el.hit_count,
          regDate: el.reg_date ? el.reg_date.slice(0, 10) : '',
          upDate: el.update_date ? el.update_date.slice(0, 10) : '',
          link: `${NavData['RADIO_MAIN'].path}/${selBoard.programId}/board/${selBoard.boardId}/${el.board_item_id}`,
        }));
        setTopData(data);
      }
    });
    return () => {
      setTopData(undefined);
      setPageInfo(undefined);
      setNormalData(undefined);
    };
  }, []);

  return (
    <div id="CommonProgramBoard" className="commonProgramBoard">
      <MainHead title={selBoard.title} mode={mode} handleSubmit={handleSubmit} />
      <div className="commonProgramBoard_content">
        <table className="table">
          <caption className="sr-only">Announcement</caption>
          <colgroup>
            <col width="8%" />
            <col width="12%" />
            <col width="*" />
            <col width="8%" />
          </colgroup>
          <thead className="table_head">
            <tr className="table_row">
              <th className="table_row_head" scope="col">
                NO
              </th>
              <th className="table_row_head" scope="col">
                DATE
              </th>
              <th className="table_row_head" scope="col">
                Title
              </th>
              <th className="table_row_head" scope="col">
                HIT
              </th>
            </tr>
          </thead>
          {topData && (
            <tbody className="table_body">
              {topData.map((v) => (
                <tr className="table_row" key={v.key} style={{ fontWeight: 'bold' }}>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    TOP
                  </td>
                  <td className="table_row_data time-fs-fixed" style={{ textAlign: 'center' }}>
                    {v.regDate}
                  </td>
                  <td className="table_row_data">
                    <Link to={v.link} className="link">
                      {v.title}
                    </Link>
                  </td>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    {v.hitCount}
                  </td>
                </tr>
              ))}
              {normalData &&
                normalData.map((v) => (
                  <tr className="table_row" key={v.key}>
                    <td className="table_row_data style_center">{v.no(topData.length)}</td>
                    <td className="table_row_data style_center time-fs-fixed">{v.regDate}</td>
                    <td className="table_row_data">
                      <Link to={v.link} className="link" title={anchorTitle}>
                        {v.title}
                      </Link>
                    </td>
                    <td className="table_row_data style_center">{v.hitCount}</td>
                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>
      {pageInfo && (
        <Pagination nowPage={pageInfo.number} totalPage={pageInfo.total_page_count} handlePageBtn={handlePageBtn} />
      )}
    </div>
  );
}
